import { inject } from "@angular/core";
import { HttpInterceptorFn } from "@angular/common/http";
import { BrowserInfoService } from "@bbwt/services/browser-info.service";

export const browserInfoInterceptor: HttpInterceptorFn = (req, next) => {
    const browserInfo = inject(BrowserInfoService);

    const headers = req.headers.set("X-Browser-Id", browserInfo.browserId).set("X-Browser-Fingerprint", browserInfo.browserFingerprint);

    const requestUpdate = req.clone({ headers });

    return next(requestUpdate);
};
